/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { NodeResizer, Handle, Position } from '@xyflow/react'
import { Flex, Text, Box, Image } from '@chakra-ui/react'
import { IEmployee } from '../../../../../../interfaces'
import { memo } from 'react'

const CustomNode: React.FC<any> = ({
  data
}: {
  data: { label: string, colaboradores: IEmployee[], cor?: string, cores: string[], nivel: number }
}) => {
  function GetTree(Tree: IEmployee[], nivel: number): any {
    return Tree.map((colab) => (
      <Flex key={colab.id} flexDir="column" align="center">
        <Flex
          flexDir="column"
          border={`1px solid ${data.cores[nivel] ? data.cores[nivel] : 'var(--Azul)'}`}
          pt="0.5rem"
          bg="var(--c1)"
          w="fit-content"
          minW="120px"
          maxW="120px"
          height="9rem"
          alignItems="center"
          justifyContent="space-between"
          borderRadius="0.25rem"
        >
          <Flex justifyContent="center">
            <Flex flexDir="column" alignItems="center">
              <Flex justifyContent="center" height="5rem" w="5rem">
                <Image
                  w="full"
                  h="full"
                  objectFit="cover"
                  borderRadius="50%"
                  src={
                    colab.avatar ||
                    'https://sigah.blob.core.windows.net/onboard/da193183-666b-42cd-ae52-da86bc76f065.png'
                  }
                />
              </Flex>
            </Flex>
          </Flex>
          <Flex w="full" justifyContent="center">
            <Text
              bg={data.cores[nivel] ? data.cores[nivel] : 'var(--Azul)'}
              width="full"
              textAlign="center"
              color="var(--c1)"
              p="0.25rem"
              fontWeight="600"
              fontSize="0.65rem"
              noOfLines={2}
            >
              {colab.nome} {colab.sobrenome}
            </Text>
          </Flex>
        </Flex>
        {colab.subordinados && (
          <Flex mt="0.5rem" gap="0.5rem">
            {GetTree(colab.subordinados, nivel + 1)}
          </Flex>
        )}
      </Flex>
    ))
  }

  return (
    <Box
      border={`1px solid ${data.cor ?? 'var(--Azul)'}`}
      borderRadius="0.25rem"
      bg="white"
      p="0.75rem"
      display="flex"
      flexDir="column"
      overflowX="auto"
      height="100%"
      alignItems="center"
      minW="650px"
      width={'100%'}
    >
      <Text
        fontWeight="900"
        mb="0.5rem"
        textAlign="center"
        fontSize="1.125rem"
        whiteSpace="normal"
        wordBreak="break-word"
        color={data.cor}
      >
        {data.label}
      </Text>

      {data.colaboradores?.length > 0 && (
        <Box
          display="flex"
          gap="0.5rem"
          w="100%"
          justifyContent="center"
          py="0.5rem"
        >
          {GetTree(data.colaboradores, data.nivel)}
        </Box>
      )}

      <NodeResizer
          minWidth={660}
          minHeight={140}
          autoScale
          color={data.cor ?? 'var(--Azul)'}
          handleStyle={{
            width: 8,
            height: 8,
            background: `${data.cor ?? 'var(--Azul)'}`,
            border: `2px solid ${data.cor ?? 'var(--Azul)'}`,
            marginTop: '4px',
            marginLeft: '4px'
          }}
          lineStyle={{
            stroke: data.cor ?? 'var(--Azul)',
            strokeWidth: 2
          }}
        />
      <Handle type="target" position={Position.Top} />
      <Handle type="source" position={Position.Bottom} />
    </Box>
  )
}

export default memo(CustomNode)
